import useFilter from "./useFilter";

function Filter({ setShowForm }) {
  const { renderTabContent } = useFilter(setShowForm);

  return (
    <div>
      {/* eslint-disable-next-line no-script-url */}
      <form action="javascript:void(0)">{renderTabContent()}</form>
    </div>
  );
}

export default Filter;
